/**
 * MetricsGrid Widget - Security metrics dashboard grid
 * Displays: Vulnerability counts, severity distribution, trends
 */
import type { ReactNode } from 'react';
import { MetricCard } from '../../shared/ui';

interface MetricData {
  icon: ReactNode;
  label: string;
  value: string | number;
  unit?: string;
  trend?: number;
  status?: 'good' | 'warning' | 'critical';
}

interface MetricsGridProps {
  metrics: MetricData[];
  className?: string;
}

export function MetricsGrid({ metrics, className = '' }: MetricsGridProps) {
  return (
    <div
      className={`
        grid grid-cols-[repeat(auto-fit,minmax(250px,1fr))] gap-6
        ${className}
      `}
      style={{
        // Staggered animation delay for each card
        animation: 'fade-in 0.5s ease-out',
      }}
    >
      {metrics.map((metric, index) => (
        <div
          key={index}
          style={{
            animationDelay: `${index * 100}ms`,
          }}
          className="animate-slide-up"
        >
          <MetricCard {...metric} />
        </div>
      ))}
    </div>
  );
}
